import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatDivider } from '@angular/material/divider';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { HasPermissionDirective } from '@ipg/ngx-frontend-toolset';
import { SETTINGS_PERMISSIONS } from '../../../guards/permission.guard';

@Component({
  selector: 'app-sidenav-menu',
  imports: [
    MatDivider,
    MatIcon,
    RouterLink,
    RouterLinkActive,
    MatTooltip,
    HasPermissionDirective,
  ],
  templateUrl: './sidenav-menu.component.html',
  styleUrl: './sidenav-menu.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'flex flex-col h-full',
  },
})
export class SidenavMenuComponent {
  /** Settings only for a user who can open one of its pages */
  protected readonly settingsPermissions = SETTINGS_PERMISSIONS;
}
